import type { MyAppsWorkspaceStarterId } from '../fileBrowser/createBlankStarterInUserStorage';
import { getNewFileStarter } from '../fileBrowser/fileTypeRegistry';

export type TextEditorTemplateId = Extract<MyAppsWorkspaceStarterId, 'txt' | 'jenc' | 'log' | 'env'>;

export type TextEditorTemplate = {
  starterId: TextEditorTemplateId;
  title: string;
  description: string;
  extension: string;
};

/** Plain-text Text Editor create options (not code/config languages). */
export const TEXT_EDITOR_TEMPLATES: readonly TextEditorTemplate[] = [
  {
    starterId: 'txt',
    title: 'Text file',
    description: 'Plain UTF-8 notes',
    extension: '.txt'
  },
  {
    starterId: 'jenc',
    title: 'Encrypted text',
    description: 'Passphrase-protected .jenc',
    extension: '.jenc'
  },
  {
    starterId: 'log',
    title: 'Log file',
    description: 'Plain log / transcript',
    extension: '.log'
  },
  {
    starterId: 'env',
    title: 'Env file',
    description: 'Environment variables',
    extension: '.env'
  }
];

export function defaultTextEditorFileName(starterId: TextEditorTemplateId): string {
  return getNewFileStarter(starterId)?.defaultName ?? `file.${starterId}`;
}

export function validateTextEditorFileName(fileName: string, extension: string): string | null {
  const trimmed = fileName.trim();
  if (!trimmed) return 'File name is required.';
  if (trimmed.includes('/') || trimmed.includes('\\')) {
    return 'File name cannot contain path separators.';
  }
  // `.env` may be the whole basename (no extra stem), or `app.env`.
  if (extension === '.env') {
    const lower = trimmed.toLowerCase();
    if (lower === '.env' || lower.endsWith('.env')) return null;
    return 'File name must be .env or end with .env.';
  }
  if (!trimmed.toLowerCase().endsWith(extension.toLowerCase())) {
    return `File name must end with ${extension}.`;
  }
  return null;
}
